export default {
  today: 'Tänään',
  tomorrow: 'Huomenna',
};
